<script>
export default {
    props: ['data', 'path'],
    name: "ipSwiperList",
    data() {
        return {
            swiperOptions: {
                observer: true,
                observeParents: true,
                simulateTouch: false,
                loop: false,
                navigation: {
                    nextEl: `.swiper-button-next`,
                    prevEl: `.swiper-button-prev`,
                }, 
                slidesPerView: 'auto',
                slidesPerGroup: 3,
                spaceBetween: '3.68%',
                pagination: {
                    el: '.swiper-pagination',
                },
            },
        };
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.$swiper
        }
    },
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <swiper class="ip_swiper_list" ref="mySwiper" :options="swiperOptions">
        <swiper-slide v-for="(item, index) in data" :key="index">
            <router-link class="item" :to="`${path}?id=${item.id}`">
                <div class="layout_bg bg" :style="`background-image: url(${item.image});`"></div>
                <div class="name">{{ item.name }}</div>
                <template v-if="item.price">
                    <div class="price" v-if="item.price == '0.00'">免费</div>
                    <div class="price" v-else>RMB {{ item.price }}</div>
                </template>
            </router-link>
        </swiper-slide>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
        <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
</template>

<style scoped lang="scss">
.ip_swiper_list{
    position: relative;
    padding: 0 .4rem;
    @media only screen and (max-width: 750px) {
        padding: 0;
    }
    .swiper-slide{
        width: 3.46rem;
        @media only screen and (max-width: 750px) {
            width: 100%;
        }
    }
    .item{
        // flex: 1;
        text-align: center;
        display: flex;
        flex-direction: column;
        gap: .2rem;
        .bg{
            height: 0;
            padding-bottom: 100%;
        }
        .name{
            font-size: .18rem;
        }
        .price{
            font-size: .17rem;
        }
        @media only screen and (max-width: 750px) {
            .name,
            .price{
                display: none;
            }
        }
    }
    --swiper-navigation-color: #999;/* 单独设置按钮颜色 */
    --swiper-navigation-size: .26rem;/* 设置按钮大小 */
    .swiper-button-prev,
    .swiper-button-next{
        top: 1.76rem;
        margin-top: 0;
        transform: translate(0, -50%);
        padding: .2rem;
        &.swiper-button-disabled{
            opacity: 0;
        }
        @media only screen and (max-width: 750px) {
            display: none;
        }
    }
    .swiper-button-prev{
        left: 0;
    }
    .swiper-button-next{
        right: 0;
    }
    .swiper-pagination{
        display: flex;
        justify-content: center;
        gap: .1rem;
        bottom: .6rem;
        display: none;
        @media only screen and (max-width: 750px) {
            display: flex;
        }
        /deep/ .swiper-pagination-bullet{
            opacity: 1;
            margin: 0;
            width: .12rem;
            height: .12rem;
            background: none;
            border: 1px solid #fff;
            &-active{
                background: #fff;
            }
        }
    }
}
</style>